import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { RewardsDialogContentModel } from 'models';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

import { RewardsEducationContent } from './rewards-education-content';

export interface RewardsEducationDialogProps {
  rewardsEducation?: RewardsDialogContentModel;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
}

@inject('routeStore', 'analytics')
export class RewardsEducationDialog extends React.Component<RewardsEducationDialogProps> {
  private handleDismiss = () => {
    this.props.routeStore.goBack();
  };

  public render(): JSX.Element {
    const toolbarAnalytics = this.props.analytics.setupTracker('RewardsEducationDialog.Close', 'Rewards Education Dialog');
    const { rewardsEducation } = this.props;

    return (
      <Layer id="join-rewards" onDismiss={this.handleDismiss}>
        <UitkFullscreenDialog dialogShow={true}>
          <UitkToolbar type={ToolbarType.CLOSE} action={this.handleDismiss} analytics={toolbarAnalytics} />
          <UitkDialogContent>
            <RewardsEducationContent content={rewardsEducation} />
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    );
  }
}
